import Marionette from "backbone.marionette";
import $ from "jquery";
import moment from "moment-timezone";

import { CANDIDATE_FEEDBACK_STATE } from "lib/constants";

import util from "../util";

const FeedbackView = Marionette.View.extend({
    template: false,
    onRender() {
        $("[data-date]").each((idx, el) => {
            const $this = $(el);
            const date = $this.data("date");
            $this.text(moment(date).format("ddd, MMM D [at] h:mmA z"));
        });

        $("input[name=feedback]").on("click touchend", (e) => {
            $('[id^="explanation-block"]').hide();

            const state = e.target.value;
            $(`#explanation-block-${state}`).show();
        });

        // respond to feedback submission
        $("#feedback-submit").on("click touchend", (e) => {
            e.preventDefault();
            const feedbackState = Number($("input[name=feedback]:checked").val());

            if (!feedbackState) {
                // complain, raise error
                $(".unfilled-error").show();
            } else {
                let isReschedule = false;
                const data = { feedback_state: feedbackState };

                // save feedback state and show corresponding message
                if (feedbackState === CANDIDATE_FEEDBACK_STATE.NO_LONGER_INTERESTED) {
                    data.feedback_reason = $("#not-interested-explanation").val();
                } else if (feedbackState === CANDIDATE_FEEDBACK_STATE.NO_SHOW) {
                    data.feedback_reason = $("#missed-explanation").val();
                } else if (
                    feedbackState === CANDIDATE_FEEDBACK_STATE.HM_NO_SHOW &&
                    $("[name=reschedule]:checked").val() === "1"
                ) {
                    data.reschedule = "1";
                    isReschedule = true;
                }

                $.ajax({
                    type: "POST",
                    url: window.location,
                    data,
                })
                    .done(() => {
                        $("#feedback-form").hide();

                        const redirect = isReschedule ? window.scheduleURL : null;
                        showFeedbackResponse(feedbackState, redirect);
                    })
                    .fail(() => {
                        $("#feedback-form").hide();
                        $("#feedback-response").css("display", "flex");
                        $("#feedback-error").show();
                    });
            }
        });

        /**
         *  Show the corresponding message dependent on what answer the candidate gave for
         *  their interview feedback
         *  This should be identical to the CANDIDATE_FEEDBACK_STATE map in models
         * */
        function showFeedbackResponse(state, redirect) {
            const feedbackResponses = {
                [CANDIDATE_FEEDBACK_STATE.GOOD_NEXT_STEPS]: "#good-feedback-response",
                [CANDIDATE_FEEDBACK_STATE.NOT_SURE]: "#unsure-feedback-response",
                [CANDIDATE_FEEDBACK_STATE.COMPANY_PASSED]: "#passed-feedback-response",
                [CANDIDATE_FEEDBACK_STATE.NO_LONGER_INTERESTED]: "#withdraw-feedback-response",
                [CANDIDATE_FEEDBACK_STATE.NO_SHOW]: "#missed-feedback-response",
                [CANDIDATE_FEEDBACK_STATE.HM_NO_SHOW]: "#hm-noshow-response",
            };
            $("#feedback-response").css("display", "flex");
            $(feedbackResponses[state]).show();

            if (redirect) {
                setTimeout(() => {
                    window.location.href = redirect;
                }, 0);
                return;
            }

            if (window.authUser) {
                setTimeout(() => {
                    util.redirectToReferral(
                        // Show first time and any other time they give 'good' feedback
                        (count) => count === 1 || Number(state) === 1,
                        "candfeedback",
                    );
                }, 2500);
            }
        }
    },
});

export default FeedbackView;
